import { root } from './online';

export const online = {
  ...root,
};
